import React, { useEffect } from 'react';

import { CategoryFields } from '__generated__/CategoryFields';
import { getProjectBrief_site } from '__generated__/getProjectBrief';
import { Currency } from 'common/utils/currency';
import BudgetField from 'projects/components/BriefFields/BudgetField';
import TimeframeField from 'projects/components/BriefFields/TimeframeField';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';

type Fields = React.ComponentProps<typeof TimeframeField>['form']['data'] &
    React.ComponentProps<typeof BudgetField>['form']['data'] & {
        currency: string;
    };

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
        category: CategoryFields | null;
    };
    site: getProjectBrief_site;
}

const TimeAndBudgetPage: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    brief,
    site,
}) => {
    const currency = form.get('currency')
        ? (form.get('currency') as Currency)
        : (site.currency as Currency);

    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'TimeAndBudget',
        });
    }, []);

    return (
        <div className="content-setting">
            <TimeframeField form={form} />
            <BudgetField form={form} currency={currency} category={brief.category!} />
        </div>
    );
};

export default TimeAndBudgetPage;
